export default {
  init() {
    // JavaScript to be fired on all pages
    $('.menu-toggle').click(function() {
      $('.nav-primary').toggleClass('nav-active');
      $('.menu-toggle').toggleClass('toggle-open');
    });

    // Carousel

    $('.carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.flex-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.logo-carousel').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: 'unslick',
        },
      ],
    });

    $('.our-values-carousel').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    //Implementing navigation of slides using mouse scroll
    $('.our-values-carousel').on('wheel', (function(e) {
      if( $('.value-scroll-trigger').last().hasClass('slick-active') ) {
        if(e.originalEvent.deltaY > 0 ) {
          $(this.slick('slickPrev'));
        }
      }

      if( $('.value-scroll-trigger').first().hasClass('slick-active') ) {
        if(e.originalEvent.deltaY < 0 ) {
          $(this.slick('slickNext'));
        }
      }
      
      e.preventDefault();
      if (e.originalEvent.deltaY < 0) {
        $(this).slick('slickPrev');
      } else {
        $(this).slick('slickNext');
      }
    }));

    $('.quote-carousel').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
    });

    $('#scroll-top').on('click', function() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    })

    // This number isnt random, the admin account is 99999999 so we need to make sure the miniscule chance of another driver
    // having the same uid as admin doesnt happen
    $('#cf7mls-next-btn-cf7mls_step-4').on('click', function(){
      $('#uid_input').val(Math.floor(Math.random() * 99999998) + 1);
    })

    document.addEventListener( 'wpcf7submit', function( event ) {
      if (event.detail.contactFormId == '274') {
        console.log('test');
        event.preventDefault();
          var inputs = event.detail.inputs;

          // set up vars
          var fullName;
          var email;
          var national;
          var address;
          var postcode;
          var dob;
          var mobileNumber;
          var driversLicense = null;
          var criminalRecord = null;
          var creditChecks = null;
          var immigrationStatus = null;
          var courierExperience;
          var courierLength;
          var ownCar;
          var drivingJobs;
          var salesCommission = null;
          var vehicleMake;
          var vehicleModel;
          var vehicleReg = '';
          var vehicleSize;
          var dates1 = '';
          var dates2 = '';
          var dates3 = '';
          var dates4 = '';
          var dates5 = '';
          var company1 = '';
          var company2 = '';
          var company3 = '';
          var company4 = '';
          var company5 = '';
          var role1 = '';
          var role2 = '';
          var role3 = '';
          var role4 = '';
          var role5 = '';
          var contactNumber1 = '';
          var contactNumber2 = '';
          var contactNumber3 = '';
          var contactNumber4 = '';
          var contactNumber5 = '';
          var contactName1 = '';
          var contactName2 = '';
          var contactName3 = '';
          var contactName4 = '';
          var contactName5 = '';
          var uniqueId;
          var whereDidYouHearFromUs;


          for ( var i = 0; i < inputs.length; i++ ) {
            
            if ( 'first-name' == inputs[i].name ) {
                fullName = inputs[i].value;
            }

            if ( 'last-name' == inputs[i].name ) {
              fullName = fullName + ' ' + inputs[i].value;
            }

            if ( 'your-email' == inputs[i].name ) {
              email = inputs[i].value;
            }

            if ( 'mobile-number' == inputs[i].name ) {
              mobileNumber = inputs[i].value;
            }

            if ( 'national-insurance' == inputs[i].name ) {
              national = inputs[i].value;
            }

            if ( 'address' == inputs[i].name ) {
              address = inputs[i].value;
            }

            if ( 'where-did-you-hear-from-us' == inputs[i].name ) {
              whereDidYouHearFromUs = inputs[i].value;
            }

            if ( 'post-code' == inputs[i].name ) {
              postcode = inputs[i].value;
            }

            if ( 'date-of-birth' == inputs[i].name ) {
              dob = inputs[i].value;
            }

            if ( 'ImmigrationStatus' == inputs[i].name ) {
              immigrationStatus = inputs[i].value;
            }

            if ( 'CreditChecks' == inputs[i].name ) {
              creditChecks = inputs[i].value;
            }

            if ( 'CriminalRecord' == inputs[i].name ) {
              criminalRecord = inputs[i].value;
            }

            if ( 'DriversLicenseCheck' == inputs[i].name ) {
              driversLicense = inputs[i].value;
            }

            if ( 'acceptance-47' == inputs[i].name) {
              if (inputs[i].value == true) {
                ownCar = true;
              } else {
                ownCar = false;
              }
            }

            if ( 'acceptance-46' == inputs[i].name) {
              if (inputs[i].value == true) {
                ownCar = false;
              } else {
                ownCar = true;
              }
            }

            if ( 'courier-experience' == inputs[i].name ) {
              courierExperience = inputs[i].value;
            }

            if ( 'how-long' == inputs[i].name ) {
              courierLength = inputs[i].value;
            }

            if ( 'driving-jobs' == inputs[i].name ) {
              drivingJobs = inputs[i].value;
            }

            if ( 'sales-commission' == inputs[i].name ) {
              salesCommission = inputs[i].value;
            }

            if ( 'vehicle-make' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleMake = inputs[i].value;
              }
            }

            if ( 'no-vehicle-make' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleMake = inputs[i].value;
              }
            }

            if ( 'registration' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleReg = inputs[i].value;
              }
            }

            if ( 'vehicle-model' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleModel = inputs[i].value;
              }
            }

            if ( 'no-vehicle-model' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleModel = inputs[i].value;
              }
            }

            if ( 'vehicle-size' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleSize = inputs[i].value;
              }
            }

            if ( 'no-vehicle-size' == inputs[i].name ) {
              if (inputs[i].value) {
                vehicleSize = inputs[i].value;
              }
            }

            if ( 'history-1-start' == inputs[i].name ) {
              dates1 = inputs[i].value;
            }

            if ( 'history-2-start' == inputs[i].name ) {
              dates2 = inputs[i].value;
            }

            if ( 'history-3-start' == inputs[i].name ) {
              dates3 = inputs[i].value;
            }

            if ( 'history-4-start' == inputs[i].name ) {
              dates4 = inputs[i].value;
            }

            if ( 'history-5-start' == inputs[i].name ) {
              dates5 = inputs[i].value;
            }

            if ( 'history-1-company' == inputs[i].name ) {
              company1 = inputs[i].value;
            }

            if ( 'history-2-company' == inputs[i].name ) {
              company2 = inputs[i].value;
            }

            if ( 'history-3-company' == inputs[i].name ) {
              company3 = inputs[i].value;
            }

            if ( 'history-4-company' == inputs[i].name ) {
              company4 = inputs[i].value;
            }

            if ( 'history-5-company' == inputs[i].name ) {
              company5 = inputs[i].value;
            }

            if ( 'history-1-role' == inputs[i].name ) {
              role1 = inputs[i].value;
            }

            if ( 'history-2-role' == inputs[i].name ) {
              role2 = inputs[i].value;
            }

            if ( 'history-3-role' == inputs[i].name ) {
              role3 = inputs[i].value;
            }

            if ( 'history-4-role' == inputs[i].name ) {
              role4 = inputs[i].value;
            }

            if ( 'history-5-role' == inputs[i].name ) {
              role5 = inputs[i].value;
            }

            if ( 'history-1-contact-name' == inputs[i].name ) {
              contactName1 = inputs[i].value;
            }

            if ( 'history-2-contact-name' == inputs[i].name ) {
              contactName2 = inputs[i].value;
            }

            if ( 'history-3-contact-name' == inputs[i].name ) {
              contactName3 = inputs[i].value;
            }

            if ( 'history-4-contact-name' == inputs[i].name ) {
              contactName4 = inputs[i].value;
            }

            if ( 'history-5-contact-name' == inputs[i].name ) {
              contactName5 = inputs[i].value;
            }

            if ( 'history-1-contact-number' == inputs[i].name ) {
              contactNumber1 = inputs[i].value;
            }

            if ( 'history-2-contact-number' == inputs[i].name ) {
              contactNumber2 = inputs[i].value;
            }

            if ( 'history-3-contact-number' == inputs[i].name ) {
              contactNumber3 = inputs[i].value;
            }

            if ( 'history-4-contact-number' == inputs[i].name ) {
              contactNumber4 = inputs[i].value;
            }

            if ( 'history-5-contact-number' == inputs[i].name ) {
              contactNumber5 = inputs[i].value;
            }

            if ( 'unique_driver_id' == inputs[i].name ) {
              uniqueId = inputs[i].value;
            }
            
          }

          // Build JSON post object
          var params = {
            'name': fullName,
            'email': email,
            'national_insurance': national,
            'address': address,
            'postcode': postcode,
            'mobile_number': mobileNumber,
            'whereDidYouHearFromUs': whereDidYouHearFromUs,
            'immigrationStatus': immigrationStatus,
            'creditChecks': creditChecks,
            'criminalRecord' : criminalRecord,
            'driversLicense' : driversLicense,
            'courier_experience': courierExperience,
            'courier_length': courierLength,
            'salesCommission': salesCommission,
            'drivingJobs' : drivingJobs,
            'vehicle_make': vehicleMake,
            'vehicle_model': vehicleModel,
            'vehicle_reg': vehicleReg,
            'vehicle_size': vehicleSize,
            'ownCar' : ownCar,
            'dob': dob,
            'unique_driver_id': uniqueId,
            'references' : {
              '1': {
                'dates': dates1,
                'company': company1,
                'role': role1,
                'contact_number': contactNumber1,
                'contact_name': contactName1,
              },
              '2': {
                'dates': dates2,
                'company': company2,
                'role': role2,
                'contact_number': contactNumber2,
                'contact_name': contactName2,
              },
              '3': {
                'dates': dates3,
                'company': company3,
                'role': role3,
                'contact_number': contactNumber3,
                'contact_name': contactName3,
              },
              '4': {
                'dates': dates4,
                'company': company4,
                'role': role4,
                'contact_number': contactNumber4,
                'contact_name': contactName4,
              },
              '5': {
                'dates': dates5,
                'company': company5,
                'role': role5,
                'contact_number': contactNumber5,
                'contact_name': contactName5,
              },
            },
          }
 
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://drivers.imdemo.co.uk/api/drivers', true);
        //xhr.open('POST', 'http://nwdrivers.test/api/drivers', true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        
        xhr.send(JSON.stringify(params));
      }
      
    });
  
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js